import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Spinner from '../../../components/react/spinner/spinner';
import { Redirect } from 'react-router-dom';
import AlertPopup from '../../../components/react/alert_popup/alert_popup';
import './verification_email_sent.scss';

const VerificationEmailSent = ({ emailRecipient, registerUserRequest, mailTo }) => {
  const [alertData, setAlertData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  /**
   * Triggers a registration user request
   *
   * @returns {undefined}
   */
  const resendActivationEmail = async () => {
    setIsLoading(true);

    try {
      await registerUserRequest();
    } catch {
      setAlertData({
        type: 'error',
        message: 'Error re-sending user registration request, please try again.',
      });
    } finally {
      setIsLoading(false);
    }
  };

  const renderTitle = <div className='title mt-5 mb-3'>Check your inbox</div>;

  const renderSubtitle = (
    <div className='subtitle text-gray text-start mb-3 pb-4'>
      Click the link in the activation email we just sent to <b>{emailRecipient}</b> to complete
      your account set up. This link will expire in <b>2 hours</b>.
    </div>
  );

  const renderHelp = (
    <div className='help mt-4 text-start'>
      <b>Didn&apos;t receive an email?</b>
      <ul className='list-arrows mt-4 mb-sm-5 mb-0'>
        <li className='mb-2 text-gray-li'>Check your spam folder.</li>
        <li className='mb-2 text-gray-li'>
          Does your email address above look right? If not, restart your registration with the
          correct email address.
        </li>
      </ul>
    </div>
  );

  const renderContactLink = (
    <div className='contact'>
      If you still have not received the email after resending, please{' '}
      <a href={`mailto:${mailTo}`} target='_blank' rel='noreferrer'>
        contact our support team
      </a>
      .
    </div>
  );

  if (!emailRecipient) {
    const redirectTo = window.location.pathname.replace('/verification-sent', '');
    return <Redirect push to={redirectTo} />;
  }

  return (
    <>
      <AlertPopup alertData={alertData} setAlertData={setAlertData} />
      <div data-testid='verification-email-sent' className='verification-email-sent'>
        {renderTitle}
        {renderSubtitle}
        {renderHelp}
        <button
          data-testid='resend-activation-email'
          type='button'
          className='btn btn-dark w-100 btn-lg btn-activation mt-3 mb-3'
          onClick={resendActivationEmail}
        >
          <strong>Resend activation email</strong>
        </button>
        {renderContactLink}
        <Spinner isLoading={isLoading} isAbsolute={true}></Spinner>
      </div>
    </>
  );
};

VerificationEmailSent.defaultProps = {
  mailTo: 'registration@devex.com',
};

VerificationEmailSent.propTypes = {
  emailRecipient: PropTypes.string.isRequired,
  registerUserRequest: PropTypes.func.isRequired,
  mailTo: PropTypes.string,
};

export default VerificationEmailSent;
